import React, { Component } from 'react'
import { Form, Field, FieldArray } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired, vEmail, vStandardNumber, vMin } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import SelectPretty from 'components/Input/SelectPretty/SelectPretty'
import FieldArrayRows from 'components/Input/FieldArrayRows'

const recordOptions = [
  {
    name: 'Yes (10c/min)',
    value: true,
  },
  {
    name: 'No',
    value: false,
  },
]

const vMin5 = vMin(5)

const ArrayValueField = props => (
  <Field component={Input} label="Number" validate={[vRequired, vStandardNumber]} {...props} />
)

export default class ForwardCallForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, flow } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Forward the call to another phone number.
          {flow.type !== 'phone_system_incoming_call' &&
            ' All numbers will ring simultaneously. Note, costs vary based on the type of number you are forwarding to. '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        {flow.type === 'phone_system_incoming_call' ? (
          <ArrayValueField name="number[0]" />
        ) : (
          <FieldArray
            name="number"
            FieldComponent={ArrayValueField}
            component={FieldArrayRows}
            validate={[vRequired]}
          />
        )}
        {flow.type === 'phone_system_incoming_call' ? null : (
          <>
            <Field
              label="Record Call"
              name="record"
              component={SelectPretty}
              options={recordOptions}
              validate={[vRequired]}
            />
            <Field
              label="Notification email"
              name="notificationEmail"
              component={Input}
              info="Optionally, send an email to notify you of each recording. If empty, no emails will be sent."
              validate={[vEmail]}
            />
            <Field
              label="Timeout"
              name="timeout"
              parse={value => Number(value)}
              component={Input}
              type="number"
              info="How long before the call is marked as 'not answered'. 15 seconds is a good value if you want to use voicemail."
              validate={[vMin5]}
            />
          </>
        )}
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ForwardCall/ForwardCallForm.jsx